import { render, staticRenderFns } from "./TaskAppointmentsForm.vue?vue&type=template&id=9aa8c898&lang=pug"
import script from "./TaskAppointmentsForm.vue?vue&type=script&lang=js"
export * from "./TaskAppointmentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports